<div class="mb-3">
  <label class="form-label d-flex justify-content-between align-items-center fw-semibold text-label">
    <span>Email <span class="required-dot">●</span></span>
    <span class="unique-badge">must be unique</span>
  </label>
  <div class="input-container">
    <input type="email" class="form-control custom-input"
      [class.is-invalid]="validationState.status === 'error' || validationState.status === 'conflict'"
      [class.is-valid]="validationState.status === 'valid'" placeholder="e.g. sara.ridouani@example.com" [value]="value"
      (input)="onInput($event)" />

    <!-- Spinner for Checking -->
    @if(validationState.status === 'checking') {
    <div class="status-icon spinner">
      <div class="spinner-border spinner-border-sm text-teal" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    }

    <!-- Valid Icon -->
    @if(validationState.status === 'valid') {
    <span class="status-icon valid-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#3DA66E" class="bi bi-check-circle-fill"
        viewBox="0 0 16 16">
        <path
          d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
      </svg>
    </span>
    }

    <!-- Error Icon -->
    @if(validationState.status === 'error') {
    <span class="status-icon error-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#E53E3E"
        class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
        <path
          d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
      </svg>
    </span>
    }

    <!-- Conflict Icon -->
    @if(validationState.status === 'conflict') {
    <span class="status-icon conflict-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#DD6B20"
        class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
        <path
          d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
      </svg>
    </span>
    }
  </div>

  <!-- Messages below input -->
  <div class="mt-1">

    @if(validationState.status === 'idle' || validationState.status === 'checking') {
    <div class="form-text text-muted">
      Used for login and notifications
    </div>
    }
    @if(validationState.status === 'valid') {
    <div class="valid-message">
      ✓ Available
    </div>
    }
    @if(validationState.status === 'error') {
    <div class="error-message">
      {{ validationState.message || 'This email format is invalid' }}
    </div>
    }
    @if(validationState.status === 'conflict') {
    <div class="conflict-message">
      This email is already in use by {{ validationState.conflictUser?.full_name }}.
    </div>
    }
  </div>
</div>